import { PERMISSION } from '@/constants/permission.constant';

const list = () => import('@/views/buy-car/List.vue');
const edit = () => import('@/views/buy-car/Edit.vue');

export const BuyCarRoute = [
  {
    path: '/inbox/buy-car',
    name: 'buy-car-list',
    component: list,
    meta: { requiresAuth: false, permissions: [PERMISSION.BUY_CAR_READ] },
  },
  {
    path: '/inbox/buy-car/:id/edit',
    name: 'buy-car-update',
    component: edit,
    meta: { requiresAuth: false, permissions: [PERMISSION.BUY_CAR_UPDATE] },
  },
];
